// Action Types
export const SUBMIT_DEMO_REQUEST = "SUBMIT_DEMO_REQUEST";
export const SUBMIT_DEMO_SUCCESS = "SUBMIT_DEMO_SUCCESS";
export const SUBMIT_DEMO_FAILURE = "SUBMIT_DEMO_FAILURE";
export const RESET_DEMO_REQUEST_STATUS = "RESET_DEMO_REQUEST_STATUS";

export const resetDemoRequestStatus = () => ({
  type: RESET_DEMO_REQUEST_STATUS,
});

// Action Creators
export const submitDemoRequest = (formData) => {
  return (dispatch) => {
    dispatch({
      type: SUBMIT_DEMO_REQUEST,
      payload: formData,
    });
  };
};

export const submitDemoSuccess = (message) => ({
  type: SUBMIT_DEMO_SUCCESS,
  payload: message,
});

export const submitDemoFailure = (error) => ({
  type: SUBMIT_DEMO_FAILURE,
  payload: error,
});